import React, { useState, useRef } from 'react'

import DataContextProvider from './DataContext'
import Panel from '../../../elem/panel/Panel'
import { aggregatePanel as panelClassConfig } from '../../../../utils/styles/panelStyles'
// import { AppStateContext } from '../AppStateContext'
import AggregateHeader from './AggregateHeader'
import AggregateChart from './AggregateChart'
import TimeWindowDropdown from './TimeWindowDropdown'

const Aggregate = ({ width }) => {
    const chartRef = useRef(null)
    const [isCollapsed, setCollapsed] = useState(false)

    return (
        <Panel panelClassConfig={panelClassConfig(width)}>
            <div className="explorerWrapper">
                <DataContextProvider>
                    <AggregateHeader
                        chartRef={chartRef}
                        isCollapsed={isCollapsed}
                        setCollapsed={setCollapsed}
                    />
                    <div className={isCollapsed ? `is-collapsed` : ``}>
                        <TimeWindowDropdown />
                        <div ref={chartRef} className={`chartWrapper`}>
                            <AggregateChart />
                        </div>
                    </div>
                </DataContextProvider>
            </div>
        </Panel>
    )
}

export default Aggregate
